import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import i18next from 'i18next';

import { Paragraph, View } from '@uncinc/react-drupal-core';
import { Container, Button } from '@uncinc/uncinc-react-kitchen-sink';
import {
  Breadcrumbs,
  TitleHeaderBlock,
  WysiwygField,
} from '../../../../components';

import './style.scss';

const StaffFull = ({ entity, className }) => {
  const nid = entity.getIn(['nid', 0, 'value']);
  const image = entity.getIn(['field_teaser_media', 0, 'styles', 'large'], entity.getIn(['field_media', 0, 'styles', 'large']));
  const imageAlt = entity.getIn(['field_teaser_media', 0, 'alt'], entity.getIn(['field_media', 0, 'alt']));
  const position = entity.getIn(['field_function', 0, 'value'], '');
  const email = entity.getIn(['field_email', 0, 'value'], '');
  const linkedin = entity.getIn(['field_linkedin', 0, 'uri'], '');
  const classes = classNames(className, ['StaffFull']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container small>

        {/* Breadcrumbs */}
        <Breadcrumbs includeCurrent />

        <div className="StaffFull__content">
          <div className="StaffFull__contentWrapper">

            <img className="StaffFull__image" src={image} alt={imageAlt} />

            <div className="StaffFull__name">
              <h1>{entity.getIn(['title', 0, 'value'])}</h1>

              <div className="StaffFull__function">{position}</div>
            </div>

            <div className="StaffFull__intro">
              {entity.getIn(['body', 0, 'processed']) ? (
                <WysiwygField
                  property="schema:text"
                  className="node--page--body font-size--body--large"
                  html={entity.getIn(['body', 0, 'processed'], '')}
                />
              ) : null}
            </div>
          </div>

          {(email || linkedin) &&
            <div className="StaffFull__buttons">
              {email &&
                <Button
                  primary
                  href={'mailto:' + email}
                  className="Button--mail"
                >
                  {i18next.t('send_email')}
                </Button>}
              {linkedin &&
                <Button
                  primary={false}
                  className="Button--tertiary"
                  href={linkedin}
                >
                  {i18next.t('to_linkedin')}
                </Button>}
            </div>}
        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.getIn(['id', 0, 'value']);
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
                mode="small"
              />
            );
          })}
        </div>
      ) : null}

      {/* Show related/recent items at the bottom */}
      <TitleHeaderBlock
        title={i18next.t('related_content')}
      >
        <View
          id="latest_content"
          display="by_expert"
          args={[nid]}
        />
      </TitleHeaderBlock>
    </article>
  );
};

export default StaffFull;
